/* eslint-disable no-unused-vars */
// theme.js
import { extendTheme } from '@chakra-ui/react';
import tinycolor from 'tinycolor2';
// Component style overrides
import Button from './components/button';
import Switch from './components/switch';
import Input from './components/input';
import Table from './components/table';

const themeColors = {
  bg: '#efefef',
  text: '#3a3a3a',
  titles: '#000',
  contrast: '#fff',
  lightContrast: '#f5f5f5',
  link: '#000',
  hover: '#e8503e',
  brand: '#4eb3b9',
  accent: '#e8503e',
  success: '',
  error: '',
};

const {
  bg, brand, accent, text, link, hover, contrast, lightContrast, success, error,
} = themeColors;
const overrides = {
  styles: {
    global: {
      // styles for the `body`
      body: {
        bg,
        color: text,
      },
      // styles for the `a`
      a: {
        color: link,
        fontWeight: '500',
        display: 'inline-block',
        _hover: {
          color: hover,
          textDecoration: 'none',
        },
      },
    },
  },

  colors: {
    brand,
    accent,
    text,
    contrast,
    lightContrast,
    'brand.light': tinycolor(brand).brighten(20).desaturate().toString(),
    'brand.dark': tinycolor(brand).darken(10).toString(),
  },
  fonts: {
    heading: 'Butler Stencil',
    body: 'Roboto',
  },
  components: {
    Button,
    Input,
    Switch,
    Table,
  },
};

export const customTheme = extendTheme(overrides);
